import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {contractTotalAssets$} from './assets-contract';
import {botTradeAssets$, contractTotalAssetsAll$, copyTradeAssets$} from './all/assets-contract-all';
import {Assets} from '@/types';

export interface UAssetsContract {
  type: 'account-assets';
  data: {
    assets: Assets;
  };
}
export interface UAssetsContractAll {
  type: 'account-assets-all';
  data: {
    assets: Assets;
  };
}
export interface UAssetsContractBotTrade {
  type: 'account-assets-bot-trade';
  data: {
    assets: Assets;
  };
}
export interface UAssetsContractCopyTrade {
  type: 'account-assets-copy-trade';
  data: {
    assets: Assets;
  };
}

export function subscribeContractTotalAssets() {
  contractTotalAssets$
    .pipe(map((assets) => <UAssetsContract>{type: 'account-assets', data: {assets}}))
    .subscribe((msg) => toUiMsg$.next(msg));

  contractTotalAssetsAll$
    .pipe(map((assets) => <UAssetsContractAll>{type: 'account-assets-all', data: {assets}}))
    .subscribe((msg) => toUiMsg$.next(msg));

  botTradeAssets$
    .pipe(map((assets) => <UAssetsContractBotTrade>{type: 'account-assets-bot-trade', data: {assets}}))
    .subscribe((msg) => toUiMsg$.next(msg));

  copyTradeAssets$
    .pipe(map((assets) => <UAssetsContractCopyTrade>{type: 'account-assets-copy-trade', data: {assets}}))
    .subscribe((msg) => toUiMsg$.next(msg));
}
